import { createRoot } from "react-dom/client";
import i18n from "@igoudar/i18n";
import { readPortalConfig } from "./runtime-config";
import "./style.css";
function language() {
  document.documentElement.lang = i18n.language;
  document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
}
language();
i18n.on("languageChanged", language);
document.documentElement.dataset.theme = "light";
const root = createRoot(document.getElementById("root")!);
try {
  const config = readPortalConfig();
  void import("./session")
    .then(({ startPublicSession }) => startPublicSession(root, config))
    .catch(() =>
      root.render(
        <main className="portal-shell">
          <h1>{i18n.t("portal.title")}</h1>
          <p role="alert">{i18n.t("portal.configuration")}</p>
        </main>,
      ),
    );
} catch {
  root.render(
    <main className="portal-shell">
      <h1>{i18n.t("portal.title")}</h1>
      <p role="alert">{i18n.t("portal.configuration")}</p>
    </main>,
  );
}
